// external libs
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
	onChangeIsMobile: ['isMobile'],
	onSetNextPage: ['nextPage'],
	onChangeWebType: ['webType'],
})

export const NavigationTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const WEB_TYPES = {
	DEFAULT: 0,
	HOUSEHOLD: 1,
	LIABILITY: 2,
}

export const SCREENS = {
	INIT: 0,
	PROPERTY_TYPE: 1,
	PROPERTY: 2,
	HOUSEHOLD: 3,
	HOUSEHOLD_DETAIL: 4,
	LIABILITY: 5,
	LIABILITY_DETAIL: 6,
	CUSTOMER_FORM: 7,
	FINAL: 8,
}

export const SCREEN_VALIDATE = [SCREENS.PROPERTY_TYPE, SCREENS.HOUSEHOLD, SCREENS.HOUSEHOLD_DETAIL, SCREENS.LIABILITY,
	SCREENS.LIABILITY_DETAIL, SCREENS.CUSTOMER_FORM]

export const BASED_ON = {
	HOUSEHOLD_ACTIVE: 1,
	LIABILITY_ACTIVE: 2,
	PROPERTY_ACTIVE: 3,
}

export const NOT_IN_USE = '/not in use'

export const INITIAL_STATE = Immutable({ // eslint-disable-line
	isMobile: false,
	activeStep: 0,
	webType: WEB_TYPES.DEFAULT,
	nextPage: '',
})

/* ------------- Reducers ------------- */

export const onChangeIsMobile = (state, { isMobile }) =>
	state.merge({ isMobile })

export const setNextPage = (state, { nextPage }) =>
	state.merge({ nextPage })

export const changeWebType = (state, { webType }) =>
	state.merge({ webType: Object.values(WEB_TYPES).indexOf(webType) !== -1 ? webType : WEB_TYPES.DEFAULT })

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
	[Types.ON_CHANGE_IS_MOBILE]: onChangeIsMobile,
	[Types.ON_SET_NEXT_PAGE]: setNextPage,
	[Types.ON_CHANGE_WEB_TYPE]: changeWebType,
})

export const getNavigationSteps = (navigation, householdActive, liabilityActive, propertyActive) => navigation.reduce((acc, item) => {
	if (item.path !== NOT_IN_USE && acc.indexOf(item.path) === -1) {
		if (!item.basedOn) {
			acc.push(item.path)
		} else {
			if (item.basedOn === BASED_ON.PROPERTY_ACTIVE && propertyActive ||
				item.basedOn === BASED_ON.HOUSEHOLD_ACTIVE && householdActive ||
				item.basedOn === BASED_ON.LIABILITY_ACTIVE && liabilityActive
			) {
				acc.push(item.path)
			}
		}
	}
	return acc
}, [])

export const getActiveScreens = (navigation, pathname, stepsDefault = false) => {
	const steps = stepsDefault === false ? getNavigationSteps(navigation) : stepsDefault
	return navigation.reduce((acc, item) => {
		if (steps.indexOf(item.path) !== -1 && item.path === pathname) {
			acc[item.screen] = item
		}
		return acc
	}, {})
}
